/**
 * Request builders for user-facing flag endpoints.
 */

export type FlagReason =
  'spam' | 'incorrect' | 'inappropriate' | 'duplicate' | 'other';

export type FlagTargetType = 'item' | 'content_source' | 'mention';

export function createFlag(body: {
  targetType: FlagTargetType;
  targetId: string;
  reason: FlagReason;
  details?: string;
}) {
  return {
    url: '/api/flags',
    method: 'POST' as const,
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  };
}
